import type { ApiFittedCup } from '@/api/fittedComponents/fittedCup.types';
import {
    AVENIR_N6_HEADOFFSET_CUP_SIZE_THRESHOLD,
    DUAL_MOBILITY_CUP_SIZE_THRESHOLD,
} from '@/domain/catalog/cup';

/** Filter out cups with an outer diameter at or below minSize */
export function filterCupsByMinSize(cups: ApiFittedCup[], minSize: number): ApiFittedCup[] {
    return cups.filter((cup) => cup.outer_diameter > minSize);
}

/**
 * Cups offered for selection: sorted ascending by outer diameter, with the dual-mobility and
 * CoCr -6 head-offset minimum-size restrictions applied. Pure — the caller supplies the live
 * plan state as flags.
 */
export function selectableCups(
    cups: ApiFittedCup[],
    options: { dualMobility: boolean; restrictMinus6Head: boolean },
): ApiFittedCup[] {
    let result = [...cups].sort((a, b) => a.outer_diameter - b.outer_diameter);

    if (options.dualMobility) {
        result = filterCupsByMinSize(result, DUAL_MOBILITY_CUP_SIZE_THRESHOLD);
    }

    if (options.restrictMinus6Head) {
        result = filterCupsByMinSize(result, AVENIR_N6_HEADOFFSET_CUP_SIZE_THRESHOLD);
    }

    return result;
}
